import React from 'react';
import '../../styles/searchpage.css';
import '../../styles/landingPage.css';
import '../../styles/artworks.css';
import '../../styles/common_elements.css';
import Button from 'react-bulma-components/lib/components/button';
import ArtworkCard from '../cardHolders/artworksCard'
import Filter from '../../helpers/filter'
import {inject, observer} from 'mobx-react';
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../helpers/validationChecks";
import Agent from '../../api/agent'
import OB1 from '../Home/onboarding/onboarding1-modal'
import OB2 from '../Home/onboarding/onboarding2-modal'
import OB3 from '../Home/onboarding/onboarding3-modal'

@inject('userStore', 'generalStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'searchPageArtworksStore', 'categoryPageArtworksStore')
@observer
export default class searchResultspage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artworksList: [],
            uniqueContainerId: "container_" + new Date().getTime() + Math.random(),
            reachedPageEnd: false,
        }
    }

    componentDidMount() {
        if (localStorage.hasOwnProperty("userData")) {
            // if (localStorage.hasOwnProperty("userData")) {
                Agent.generalData.listOfMediums()
                    .then((res) => {
                        var MediumChoices = [];
                        // console.log("list of mediums", res)
                        res.data.data.forEach((el, idx) => {
                            MediumChoices.push({
                                "display": el.material,
                                "key": el.id
                            })
                        })
                        // console.log("medium choices look like this", MediumChoices)
                        // this.props.generalStore.setMediumAndBaseChoices(MediumChoices)
                        this.setState({
                            mediumChoices: MediumChoices
                        })
                    }
    
                    );
                Agent.generalData.listOfBases()
                    .then((res) => {
                        // console.log("list of mediums", res)
                        var BaseChoices = [];
                        // console.log("list of mediums", res)
                        res.data.data.forEach((el, idx) => {
                            BaseChoices.push({
                                "display": el.material,
                                "key": el.id
                            })
    
                            this.setState({
                                baseChoices: BaseChoices
                            })
                        })
                    }
    
                    )

            this.props.categoryPageArtworksStore.getAllArtworksByCategory((this.props.match.params.category == "just-in") ? "" : this.props.match.params.category)
                .then((res) => {
                    if (res) {
                        if (res.data)
                            this.setState({
                                count: res.data.count,
                                artworksList: res.data.data
                            })
                    }
                })
            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            // console.log("tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    // console.log("tell i am coming here at leats")
                    this.props.navigatorStore.openOB3Modal();
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        } else {
            // console.log("coming hihi")
            this.props.categoryPageArtworksStore.getAllArtworksByCategoryPublic((this.props.match.params.category == "just-in") ? "" : this.props.match.params.category)
                .then((res) => {
                    if (res) {
                        this.setState({
                            count: (res.data) ? res.data.count : "",
                            artworksList: res.data.data,
                            shareUrl: true
                        })
                    }
                })
        }
        document.addEventListener('scroll', this.trackScrolling);
    }
    componentWillReceiveProps(nextProps) {
        // console.log('[mounted] srchpage next hihihuhu', this.state.shareUrl)
        var str = nextProps.match.params.category;
        let searchableString = str;
        // console.log('[componentWillReceiveProps] srchpage ', nextProps.match.params.search)
        if (searchableString != this.props.match.params.category) {
            // console.log('[mounted] srchpage next hihihuhu')
            if (localStorage.hasOwnProperty("userData")) {
                this.props.categoryPageArtworksStore.getAllArtworksByCategory((this.props.match.params.category == "just-in") ? "" : this.props.match.params.category)
                    .then((res) => {
                        if (res) {
                            if (res.data)
                                this.setState({
                                    count: res.data.count,
                                    artworksList: res.data.data
                                })
                        }
                    })
            }
        }
        else setTimeout(() => {
            if (this.state.shareUrl && (!!this.props.authStore.loginDone || this.props.authStore.RegisterSuccess)) {
                this.setState({
                    shareUrl: false,

                }, () => {

                    // console.log('[mounted] srchpage next hihihuhu')
                    // console.log('[mounted] srchpage next hihihuhu,query')
                    if (localStorage.hasOwnProperty("userData")) {
                        this.props.categoryPageArtworksStore.getAllArtworksByCategory((this.props.match.params.category == "just-in") ? "" : this.props.match.params.category)
                            .then((res) => {
                                if (res) {
                                    this.setState({
                                        count: (res.data) ? res.data.count : "",
                                        artworksList: res.data.data
                                    })
                                }
                            })
                        if (this.props.authStore.onboardingThreeIncomplete
                            || this.props.authStore.onboardingTwoIncomplete) {
                            // console.log('[mounted] srchpage next hihihuhu')
                            this.props.navigatorStore.openOB3Modal();
                        } else if (this.props.authStore.RegisterSuccess || localStorage.getItem("just_registered")) {
                            // console.log('[mounted] srchpage next hihihuhu')
                            localStorage.removeItem("just_registered");
                            this.props.navigatorStore.openOB1Modal();

                        }
                    }

                })
            }
        }, 1000)

        // document.addEventListener('scroll', this.trackScrolling);

    }

    componentWillUnmount() {
        // console.log("unmounted")
        document.removeEventListener('scroll', this.trackScrolling);
        localStorage.removeItem("preferred_dimension");
        this.props.categoryPageArtworksStore.resetPagination();

    }

    loadFunc(q) {
        if (localStorage.hasOwnProperty("userData")) {
             this.props.categoryPageArtworksStore.loadmore();
            if (this.state.count <= this.props.categoryPageArtworksStore.paginationLimit) {
                return;
            }
            // console.log("this query goes in", this.state.query)
            this.props.categoryPageArtworksStore.getAllArtworksByCategory(this.state.query || this.props.match.params.category, true)
                .then((res) => {
                    if (res) {
                        var joined = this.state.artworksList && this.state.artworksList.concat(res.data.data)
                        this.setState({
                            artworksList: joined
                        })
                    }
                })
        }
    }

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById(this.state.uniqueContainerId);
        let reachedPageEndNow = this.isBottom(wrappedElement);
        // console.log('[trackScroll] ', { reachedPageEndNow, reachedPageEnd: this.state.reachedPageEnd });
        if (this.isBottom(wrappedElement)) {
            // console.log('[trackScroll] FAKE ');
        };
        if ((reachedPageEndNow && !this.state.reachedPageEnd) || (!reachedPageEndNow && this.state.reachedPageEnd)) {
            this.setState({ reachedPageEnd: reachedPageEndNow })
          //  reachedPageEndNow &&  console.log('[trackScroll] REAL ');
            if (reachedPageEndNow) {
                this.loadFunc()
            }
        }
    };

    handelFilterChangeMaster(item) {
        var self = this
        this.setState({
            filterState: item,
            // showFilters: false
        }, () => {
            let filterQuery = "";
            // console.log(this.state.filterState)
            var medium = Object.keys(self.state.filterState.medium).map(function (key) {
                return [key, self.state.filterState.medium[key]];
            });

            medium.map((el) => {
                // console.log(el, el[0], el[1])
                if (el[1] == true)
                    filterQuery = filterQuery.concat(`medium=${el[0]}&`)
            })

            var base = Object.keys(self.state.filterState.base).map(function (key) {
                return [key, self.state.filterState.base[key]];
            });

            base.map((el) => {
                // console.log(el, el[0], el[1])
                if (el[1] == true)
                    filterQuery = filterQuery.concat(`base=${el[0]}&`)
            })

            var general = Object.keys(self.state.filterState.style).map(function (key) {
                return [key, self.state.filterState.style[key]];
            });
            // console.log(general);

            if (self.state.filterState.style["Following Artists"]) {

                filterQuery = filterQuery.concat(`following=True&`)
            }
            if (self.state.filterState.style["Artworks for sale"]) {
                filterQuery = filterQuery.concat(`for_sale=True&`)
            }
            if (self.state.filterState.style["Mature content"]) {
                filterQuery = filterQuery.concat(`mature=True&`)
            }
            if (self.state.filterState.style["Artwork by kids"]) {
                filterQuery = filterQuery.concat(`young=True&`)
            }
            if (self.state.filterState.pricing[`min_${localStorage.getItem('preferred_currency')}_price`]) {
                filterQuery = filterQuery.concat(`min_${localStorage.getItem('preferred_currency').toLowerCase()}_price=${self.state.filterState.pricing[`min_${localStorage.getItem('preferred_currency')}_price`]}&`)
            }
            if (self.state.filterState.pricing[`max_${localStorage.getItem('preferred_currency')}_price`]) {
                filterQuery = filterQuery.concat(`max_${localStorage.getItem('preferred_currency').toLowerCase()}_price=${self.state.filterState.pricing[`max_${localStorage.getItem('preferred_currency')}_price`]}&`)
            }

            if (self.state.filterState.size.max_height) {
                let max_height = self.state.filterState.size.max_height * (self.props.generalStore.dimensionConversionRatesToCM[self.state.filterState.size.dimension])
                filterQuery = filterQuery.concat(`max_height=${max_height}&`)
            }
            if (self.state.filterState.size.max_width) {
                let max_width = self.state.filterState.size.max_width * (self.props.generalStore.dimensionConversionRatesToCM[self.state.filterState.size.dimension])
                filterQuery = filterQuery.concat(`max_width=${max_width}&`)
            }
            if (self.state.filterState.size.max_depth) {
                let max_depth = self.state.filterState.size.max_depth * (self.props.generalStore.dimensionConversionRatesToCM[self.state.filterState.size.dimension])
                filterQuery = filterQuery.concat(`max_depth=${max_depth}&`)
            }

            filterQuery = filterQuery.concat(`${(this.props.match.params.category == "just-in") ? "" : this.props.match.params.category}`)

            // let queryString = querystring.stringify(filterQuery);
            this.props.categoryPageArtworksStore.resetPagination();
            // console.log("[  ]", filterQuery)
            this.props.categoryPageArtworksStore.getAllArtworksByCategory(filterQuery)
                .then((res) => {
                    // console.log(res)
                    this.setState({
                        query: filterQuery,
                        response: res.data,
                        artworksList: (res.data) ? res.data.data : {}
                    }, function () {
                        // console.log("[look at artworks state]", this.state.artworksList)
                    })
                })

        })
    }

    handleLoadMoreBtn() {
        this.props.navigatorStore.openSignInModal()
    }
    render() {

        // console.log("this is props", this.state.artworksList)
        return (

            <div className="searchpage-container" style={{ minHeight: "" }} >
                <div className="searchpage-content-container">

                    <div className="searchpage-heading">
                        <div className="heading-btn-row filter-heading">
                            <div className="col-12 col-md-12 col-lg-6 pl-0">
                                <h3 className="heading-left-text">{this.props.match.params.title}</h3>
                                <hr className="line-category-name"></hr>
                            </div>
                            { <Filter 
                            mediumChoices = {this.state.mediumChoices}
                            baseChoices = {this.state.baseChoices}
                            handelFilterChangeMaster={this.handelFilterChangeMaster.bind(this)} currentOverallFilterState={this.state.filterState} />}
                        </div>
                        <OB3 />
                        <OB2 />
                        <OB1 />
                    </div>
                    <div className="mt-15 mb-15 pb-15" id={this.state.uniqueContainerId}>
                        {
                            (this.state.artworksList && !this.state.artworksList.length) ? <div className="gray-category-description">No results to show</div> :
                                <ArtworkCard artworkData={this.state.artworksList} />
                        }
                    </div>

                </div>

                <div style={{ display: (!localStorage.hasOwnProperty("userData") && this.state.count > 20) ? "" : "none" }} className="col-md-12 text-center">
                    <Button id="load-more-artworks-btn" onClick={this.handleLoadMoreBtn.bind(this)}
                        className="masterpieces-tertiary-black-button btn-black btn-p10 mb-25">LOG IN TO SEE MORE</Button>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/products/categoryWiseProductsPage.js